export const TYPES = [
  ["spend", "Spend-based"], ["quantity", "Quantity-based"], ["visit", "Per visit"],
  ["transaction", "Fixed per purchase"], ["item", "Item / service"], ["stamp", "Stamp card"], ["bonus", "Bonus / multiplier"],
];
export const TYPE_LABEL = Object.fromEntries(TYPES);

export const summarize = (p) => {
  switch (p.type) {
    case "spend": return `${p.points_value} pt / TZS ${Number(p.per_amount || 0).toLocaleString()}`;
    case "quantity": return `${p.points_value} pt / ${p.per_quantity} ${p.quantity_unit}`;
    case "visit": return `${p.points_value} pt / visit`;
    case "transaction": return `${p.points_value} pt / purchase`;
    case "item": return `${(p.items || []).length} item(s)`;
    case "stamp": return `Buy ${p.stamp_required} get 1 free`;
    case "bonus": return (p.bonus_mode === "flat" ? `+${p.flat_points} pts` : `×${p.multiplier}`) + (p.weekend_only ? " · weekends" : "");
    default: return p.type;
  }
};
